import { type BaseModelProps, BaseModel } from '@mail/3promo';

export class BannerModel extends BaseModel<BaseModelProps> {
    getParent(): HTMLElement | null {
        return document.querySelector('#banners-above-toolbar');
    }
}
